// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/* CSS */
import "@css/app.pcss";

/* JS */
import 'lazysizes';
import { gsap } from "gsap";    
import { CustomEase } from "gsap/CustomEase";
import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";    
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { TextPlugin } from "gsap/TextPlugin";
/* The following plugins are Club GSAP perks */
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";
//import * as YTPlayer from 'yt-player';


/* SCRIPTS HERE */


/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';

var duration = duration || 1;
gsap.registerPlugin(Flip,ScrollTrigger,ScrollToPlugin,Draggable,MotionPathPlugin,TextPlugin,DrawSVGPlugin,ScrambleTextPlugin,SplitText,RoughEase,ExpoScaleEase,SlowMo,CustomEase);    

document.addEventListener('alpine:init', () => {

  Alpine.data('sectionStandard', (animateContent, staggerAnimations) => ({
    init() {       
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          y: 35
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1,   
              y: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.1      
            }),
            start: "top 80%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, {       
              duration: duration * 1,
              y: 35,     
              opacity: 0,                   
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete: this.postRevealFunction,                
              scrollTrigger: {
                trigger: animParent,
                start: "top 80%",
              }     
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1,
          y: 50,          
          opacity: 0,     
          // Note: Easing Pack required for easing
          ease: "expo.out",
          onComplete: this.postReveal,                
          scrollTrigger: {
            trigger: animElem,
            start: "top 80%",
          }
        })  
      }           
    },
        
    postReveal() {
      
    }    
      
  })),
  
  Alpine.data('sectionSidePhoto', (animateContent, staggerAnimations) => ({
  init() {
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          x: 35
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1,   
              x: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.1      
            }),
            start: "top 80%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, {       
              duration: duration * 1,
              y: -35,     
              opacity: 0,                   
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete: this.postRevealFunction,                
              scrollTrigger: {
                trigger: animParent,
                start: "top 80%",
              }     
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1,
          y: 50,          
          opacity: 0,     
          // Note: Easing Pack required for easing
          ease: "expo.out",
          onComplete: this.postReveal,                
          scrollTrigger: {
            trigger: animElem,
            start: "top 80%",
          }
        })  
      }                
    },
          
    postReveal() {
        
    }    
        
  })),

  /* STAT TICKER BEHAVIORS */
  Alpine.data('statisticTicker', (dataPrefix, dataSuffix, dataEndVal, dataStartVal, dataDecimals) => ({
    init() {

      // adds commas and forces 2 decimal places.
      function formatNumber(value, decimals) {
        let s = (+value).toLocaleString("en-US").split(".");
        return decimals
          ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals)
          : s[0];
      }

      const aniItem = this.$refs.statticker;
      const tickerFunction = function(el, dataPrefix, dataSuffix, dataEndVal, dataStartVal) {
        console.log(dataStartVal);
        console.log(dataEndVal);
        let obj = { num: dataStartVal };
        gsap.to(obj, {
          num: dataEndVal,
          onUpdate: () => (el.innerText = formatNumber(obj.num, 0)),
        });
      };

      gsap.to(aniItem, {      
        duration: 0,
        scale: 1,
        opacity: 1,
        delay: 0.01,
        onComplete: tickerFunction,
        onCompleteParams: [aniItem, dataPrefix, dataSuffix, dataEndVal, dataStartVal, dataDecimals],      
        scrollTrigger: {
          trigger: aniItem,
          start: "top bottom-=100px",
        }     
      });    
    },
        
    postReveal() {
      
    }    
      
  }))
})
  

if (typeof window.Alpine === "undefined") {
  Alpine.plugin(collapse);
  Alpine.plugin(focus);
  Alpine.plugin(persist);
  window.Alpine = Alpine;
  window.Swiper = Swiper;  
  Alpine.start();
}


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
  console.log("HMR")
  });
}